import { Account } from "api/mappers/accountMapper";
import {
  LEVEL_TYPE,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import { Option } from "utils/options";
import BigButton from "components/atoms/buttons/BigButton";
import { AccountInner } from "./AccountInner";
import { EditAccountInfo, UPDATE_TYPE } from "./AccountDetailContainer";
import EditModal from "../edit";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import AccountDelete from "./AccountDelete";
import CenterContentPage from "components/templates/layout/CenterContentPage";
interface Props {
  onSave: () => void;
  accountInfo: Account;
  editAccountInfo: EditAccountInfo;
  onChangeAccountInfo: (
    type: UPDATE_TYPE,
    value: number | string | boolean
  ) => void;
  logoHandleChange: (e: any) => void;
  logoImageUrl: string;
  isUpdateLoading: boolean;
  isUpdateDisabled: boolean;
  enableTransfer?: boolean;
  onModal?: (type?: string) => void;
  validateMsg: ValidateMsg;
  accountAdmins: Option[];
  accountOwnerIsFetching: boolean;
  setValidateMsg: React.Dispatch<React.SetStateAction<ValidateMsg>>;
  setEditAccountInfo: React.Dispatch<React.SetStateAction<EditAccountInfo>>;
  isMyAccount?: boolean;
  uploadingLogo: boolean;
}

export function AccountDetailPresenter(props: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const {
    onSave,
    accountInfo,
    editAccountInfo,
    onChangeAccountInfo,
    logoHandleChange,
    logoImageUrl,
    isUpdateLoading,
    isUpdateDisabled,
    enableTransfer,
    onModal,
    validateMsg,
    accountAdmins,
    accountOwnerIsFetching,
    setValidateMsg,
    setEditAccountInfo,
    isMyAccount,
    uploadingLogo,
  } = props;
  const buttons = (
    <>
      {selectedAccount.accountLevel !== LEVEL_TYPE.DW && (
        <AccountDelete
          onModal={onModal}
          accountId={editAccountInfo.accountId}
          accountName={editAccountInfo.name}
          isMyAccount={isMyAccount ?? false}
        />
      )}

      <BigButton
        id="dw_account_button__save"
        label={"Save"}
        delay
        onClickBtn={onSave}
        disabled={isUpdateDisabled}
        data-testid="account-detail-detail-button-save-save"
      />
    </>
  );

  if (!isMyAccount) {
    return (
      <EditModal
        onClickSave={onSave}
        accountInfo={accountInfo}
        editAccountInfo={editAccountInfo}
        onChangeAccountInfo={onChangeAccountInfo}
        logoHandleChange={logoHandleChange}
        logoImage={logoImageUrl}
        isUpdateLoading={isUpdateLoading}
        isUpdateDisabled={isUpdateDisabled}
        validateMsg={validateMsg}
        accountAdmins={accountAdmins}
        enableTransfer={enableTransfer ?? false}
        setValidateMsg={setValidateMsg}
        onSave={onSave}
        setEditAccountInfo={setEditAccountInfo}
        onModal={onModal}
        uploadingLogo={uploadingLogo}
      />
    );
  }

  return (
    <CenterContentPage titleComponent="Organization" buttons={buttons}>
      <AccountInner
        accountInfo={accountInfo}
        editAccountInfo={editAccountInfo}
        onChangeAccountInfo={onChangeAccountInfo}
        logoHandleChange={logoHandleChange}
        logoImage={logoImageUrl}
        isUpdateLoading={isUpdateLoading}
        validateMsg={validateMsg}
        setValidateMsg={setValidateMsg}
        accountAdmins={accountAdmins}
        accountOwnerIsFetching={accountOwnerIsFetching}
        isMyAccount={isMyAccount}
        uploadingLogo={uploadingLogo}
      />
    </CenterContentPage>
  );
}
